import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";
import { toast } from "react-hot-toast";

export const addQuickAccessApi = createAsyncThunk(
    'quickAccess/add',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.post(apiRoutes.quickAccessList, data);
            toast.success(response?.data?.message || "Quick Access Added Successfully", {
                id: "toast",
                duration: 2000,
                position: "top-center",
            });
            return response?.data;
        } catch (error) {
            let errorMsg = error?.response?.data?.message || "Something went wrong";
            if (typeof errorMsg === 'object') {
                errorMsg = Object.values(errorMsg).flat().join(', ');
            }
            toast.error(errorMsg, {
                id: "toast",
                duration: 2000,
                position: "top-center",
            });
            return rejectWithValue(error?.response?.data);
        }
    }
);

const addQuickAccessSlice = createSlice({
    name: 'addQuickAccess',
    initialState: { result: [], loading: false, error: null, message: "" },
    reducers: {
        resetAddQuickAccess: (state) => {
            state.result = [];
            state.loading = false;
            state.error = null;
            state.message = "";
        }
    },
    extraReducers: (builder) => {
        builder.addCase(addQuickAccessApi.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(addQuickAccessApi.fulfilled, (state, action) => {
            state.loading = false;
            state.result = action?.payload?.result;
            state.message = action?.payload?.message;
        });
        builder.addCase(addQuickAccessApi.rejected, (state, action) => {
            state.loading = false;
            state.error = action?.payload?.error;
            state.message = action?.payload?.message;
        });
    },
});

export const { resetAddQuickAccess } = addQuickAccessSlice.actions;
export const addQuickAccessReducer = addQuickAccessSlice.reducer;
